import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  GeneralUserTypeChoice,
  UserAuthorityChoice,
  getGeneralUserTypeName,
  getUserAuthorityName,
} from "../utils/common";
import { apiWrapper } from "../apis/CommonApi";
import * as accountApi from "../apis/AccountApi";
import { useAppContext } from "../utils/store";
import PageHeader from "../components/PageHeader";

export default function UserAccountPage() {
  const navigate = useNavigate();
  const {
    store: { id, userId, userName, userAuthority },
  } = useAppContext();
  const [isPasswordMatch, setPasswordMatch] = useState(false); // 비밀번호 일치 여부
  const [isCompletedPassword, setCompletedPassword] = useState(false); // 비밀번호 입력 완료 여부
  const [isCompletedPasswordConfirm, setCompletedPasswordConfirm] =
    useState(false); // 비밀번호 확인 입력 완료 여부
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("password", "");
    setFormDataProperty("passwordConfirm", "");
    setFormDataProperty("title", "");
    setFormDataProperty("phoneNumber", "");
    setFormDataProperty("email", "");
    setFormDataProperty("businessNumber", "");
    setFormDataProperty("userType", GeneralUserTypeChoice.FIRE_SAFETY_ADMIN);

    apiWrapper(async () => {
      const { status, data } = await accountApi.getUser(id);
      if (status === true) {
        setFormDataProperty("phoneNumber", data.phoneNumber);
        setFormDataProperty("email", data.email);
        if (data.userAuthority === UserAuthorityChoice.BUSINESS) {
          setFormDataProperty(
            "businessNumber",
            data.businessData.businessNumber
          );
        } else if (data.userAuthority === UserAuthorityChoice.GENERAL) {
          setFormDataProperty("title", data.generalData.title);
          setFormDataProperty("userType", data.generalData.userType);
        }
      }
    });
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else if (checkValid() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        let requestBody = {
          userData: {
            password: formData.password,
            phoneNumber: formData.phoneNumber.trim().replace(/-/g, ""),
            email: formData.email,
          },
        };

        if (userAuthority === UserAuthorityChoice.BUSINESS) {
          //사업자
          requestBody = {
            ...requestBody,
            businessData: {
              businessNumber: formData.businessNumber,
            },
          };
        } else if (userAuthority === UserAuthorityChoice.GENERAL) {
          //사용자
          requestBody = {
            ...requestBody,
            generalData: {
              userType: formData.userType,
              title: formData.title,
            },
          };
        }

        const { status, data } = await accountApi.updateUser(id, requestBody);
        alert(`${data}`);

        if (status === true) {
          navigate("/");
        }
      });
    }
  };

  const checkValid = () => {
    if (isPasswordMatch === false) {
      alert("비밀번호를 확인해주세요.");
    }

    return true;
  };

  const handleCheckPasswordMatch = () => {
    if (formData.password === formData.passwordConfirm) {
      setPasswordMatch(true);
    } else {
      setPasswordMatch(false);
    }
  };

  return (
    <section class="mbSection MISection">
      <PageHeader isBlack={false} title="MY 계정" isUseMenu={false} />
      <form onSubmit={handleSubmit}>
        {formData && (
          <div class="container pb-40">
            <div class="input-wrap input-join-wrap">
              <div class="input-item">
                <p class="input-title">구분</p>
                <div class="radio-group">
                  {/* "전체" 상태는 제외하고 전시 */}
                  {Object.values(UserAuthorityChoice).map((item, index) =>
                    index === 0 ? null : (
                      <>
                        <input
                          type="radio"
                          id={`userAuthority${item}`}
                          name="userAuthority"
                          value={item}
                          checked={userAuthority === item}
                        />
                        <label htmlFor={`userAuthority${item}`}>
                          {getUserAuthorityName(item)}
                        </label>
                      </>
                    )
                  )}
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">아이디</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput readonlyInput"
                    type="text"
                    value={userId}
                    readonly
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">비밀번호</p>
                {/* <div class="input-inner-wrap">
                  <button class="btn btn-line btn-chePwd">비밀번호 변경</button>
                </div> */}
                <div class="input-inner-wrap input-duble-wrap">
                  <input
                    class="defaultInput"
                    type="password"
                    placeholder="비밀번호를 입력해주세요."
                    name="password"
                    value={formData.password}
                    onChange={onChange}
                    onBlur={() => {
                      formData.password
                        ? setCompletedPassword(true)
                        : setCompletedPassword(false);
                      handleCheckPasswordMatch();
                    }}
                    required
                  />
                  <input
                    class="defaultInput"
                    type="password"
                    placeholder="비밀번호를 다시 입력해주세요."
                    name="passwordConfirm"
                    value={formData.passwordConfirm}
                    onChange={onChange}
                    onBlur={() => {
                      formData.passwordConfirm
                        ? setCompletedPasswordConfirm(true)
                        : setCompletedPasswordConfirm(false);
                      handleCheckPasswordMatch();
                    }}
                    required
                  />
                </div>
                {/* <p class="input-guide-txt">
                  비밀번호의 글자나 특수문자 등 제한을 두신다면 여기에
                  작성해주세요.
                </p> */}
                {isCompletedPassword &&
                  isCompletedPasswordConfirm &&
                  isPasswordMatch === false && (
                    <p class="input-guide-txt red">
                      비밀번호가 일치하지 않습니다.
                    </p>
                  )}
              </div>
              <div class="input-item">
                <p class="input-title">사용자 이름</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput readonlyInput"
                    type="text"
                    value={userName}
                    readonly
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">직함/직책</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={onChange}
                    required
                  />
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">휴대폰 번호</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput"
                    type="text"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={onChange}
                    required
                  />
                  {/* <button class="btn-verify">변경</button> */}
                </div>
              </div>
              <div class="input-item">
                <p class="input-title">이메일</p>
                <div class="input-inner-wrap">
                  <input
                    class="defaultInput readonlyInput"
                    type="text"
                    name="email"
                    value={formData.email}
                    readOnly
                  />
                  {/* <button class="btn-verify">변경</button> */}
                </div>
              </div>
              {userAuthority === UserAuthorityChoice.BUSINESS && (
                <div class="input-item input-busines">
                  <p class="input-title">사업자 번호</p>
                  <div class="input-inner-wrap">
                    <input
                      class="defaultInput"
                      type="text"
                      placeholder="'-' 제외 숫자 10자리"
                      name="businessNumber"
                      value={formData.businessNumber}
                      onChange={onChange}
                      required
                    />
                  </div>
                </div>
              )}
              {userAuthority === UserAuthorityChoice.GENERAL && (
                <div class="input-item">
                  <p class="input-title">사용자 구분</p>
                  <div class="radio-group col">
                    {Object.values(GeneralUserTypeChoice).map((item, index) => (
                      <>
                        <input
                          type="radio"
                          key={index}
                          id={`userType${item}`}
                          name="userType"
                          value={item}
                          checked={formData.userType === item}
                          onChange={onChange}
                        />
                        <label htmlFor={`userType${item}`}>
                          {getGeneralUserTypeName(item)}
                        </label>
                      </>
                    ))}
                  </div>
                </div>
              )}
              <div class="btn-wrap">
                <Link to="/withdraw/" class="btn btn-withdraw">
                  회원 탈퇴
                </Link>
              </div>
            </div>
          </div>
        )}
        <div class="btmBtnWrap">
          <button
            type="button"
            class="btn btn-grey"
            onClick={() => navigate(-1)}
          >
            취소
          </button>
          <button type="submit" class="btn btn-black">
            저장
          </button>
        </div>
      </form>
    </section>
  );
}
